import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthFormUser } from './models/auth.model';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public auth: AuthFormUser = {
    username: '',
    password: '',
    site: null
  };
  public badCredentials: boolean;
  private _site: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((data) => {
      this.auth.site = data['site']
    })
    this.badCredentials = false;
  }

  public onSubmit() {
    this.badCredentials = false;
    const validation = this.validateFields();

    if (validation) {
      this.authService.login(this.auth).subscribe({
        next: (response) => {
          // console.log(response);
          const snapshot = this.activatedRoute.snapshot;
          const viewIdParam = localStorage.getItem('view_id');
          if (viewIdParam) {
            this.router.navigate([`/${snapshot.params['site']}`], {
              queryParams: { view_id: viewIdParam },
            });
          } else {
            this.router.navigate([`/${snapshot.params['site']}`]);
          }
        },
        error: (error) => {
          console.error(error);
          this.badCredentials = true;
        },
      });
    } else {
      console.log(validation);
    }

    // const l = this.userService.login(this.auth).subscribe({
    //   next: (res: AuthUser)=>{
    //     if(res && res.token && res.user){
    //       this.router.navigate(['/list']);
    //     }else{
    //       this.auth.error = 'API bad response';
    //     }
    //   },
    //   error: (err)=>{
    //     this.auth.error = err.error;
    //   }
    // });
    // this.subscriptions.push(l);
  }

  private validateFields(): boolean {
    if (this.auth.username == '' || this.auth.password == '') {
      return false;
    }
    return true;
  }
}
